//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuCms',
  data() {
    return {}
  },
  computed: {
    menu() {
      return [
        { path: '/', name: this.$t('Home'), icon: 'home' },
        { path: '/search', name: this.$t('Search'), icon: 'search' },
        { path: '/account/bets', name: this.$t('My Bets'), icon: 'history', count: 0 },
        { path: 'live', name: this.$t('In-Play'), icon: 'tachometer-alt', count: 0 },
        { path: '/esports', name: this.$t('E-Gaming'), icon: 'gamepad', count: 0 },
        { path: '/virtual', name: this.$t('Virtual Sports'), icon: 'gamepad', count: 0 },
        { path: '/horse-racing', name: this.$t('Horse Racing'), icon: 'horse', count: 0 },
        { path: '/greyhounds', name: this.$t('Greyhounds'), icon: 'dog', count: 0 },
        { path: '/promotions', name: this.$t('Promotions'), icon: 'gift', count: 0 },
      ]
    },
    popular_pages() {
      const section = Array.isArray(this.$store.state.globals_new)
          ? this.$store.state.globals_new.find(obj => obj.handle === 'popular_pages')
          : null

      const items = Array.isArray(section?.items) ? section.items : []

      return items
          .filter(p => {
            if (!p.active) return false
            if (p?.footer_only) return false
            return !(p.visibility === 'auth' && !this.user);

          })
          .slice()
          .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
          .map(p => {
            const url =
                !p.is_external
                    ? (p.url?.startsWith('/') ? p.url : '/' + (p.url || ''))
                    : p.url

            return { ...p, url }
          })
    }

  },
  mounted() {},
  methods: {

    openGlobalIframe(url = '/help') {
      this.loadGlobalIframe('open_page', {'url': url})
    },
  }
}
